import React from 'react';


interface Props {
  children: React.ReactNode;
  content: React.ReactNode;
}

const Root = ({ children, content: _content }: Props) => {
  return children;
};

export default React.memo(Root);
